/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */
import Util from '@/util';

const theState = {
    plainSessions: [],
    loading: false,
    deleting: false,
    showDialog: false,
    showDeleteAllDialog: false,
    selectedSessionId: '',
    ssoId: '',
};

function mapSession(session) {
    const services = session.services || [];
    const deviceNamesIds = services.map((service) => {
        const trackingStream = session.tracking_streams[service];
        let nameOrId = null;
        if (trackingStream && trackingStream.attributes) {
            const information = trackingStream.attributes;
            nameOrId = information.device_display_name || information.device_name;
            nameOrId = nameOrId || information.device_id;
        }
        return nameOrId;
    }).filter(nameOrId => typeof nameOrId !== 'undefined' && nameOrId !== null);

    return {
        device_name_id: deviceNamesIds.join(', '),
        device_class: session.device_class,
        tracking_id: session.tracking_id,
        session_id: session.session_id,
        services: session.services.join(', '),
        stores: session.stores.join(', '),
        timestamp: session.timestamp ? Util.formatTimestamp(session.timestamp) : '-',
        tracking_streams: session.tracking_streams,
    };
}

const getters = {
    sessions(state) {
        return state.plainSessions.map(session => mapSession(session));
    },

    selectedSession(state) {
        const selectedSession = state
            .plainSessions
            .filter(session => session.session_id === state.selectedSessionId);
        return selectedSession.length === 1 ? mapSession(selectedSession[0]) : ({
            device_name_id: '',
            device_class: '',
            tracking_id: '',
            session_id: '',
            services: '',
            stores: '',
            timestamp: '-',
            tracking_streams: [],
        });
    },
};

const actions = {
    deleteSession({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            commit('setDeleting', true);
            Api.customer.terminateSession(state.selectedSessionId)
                .then(() => {
                    commit('setDeleting', false);
                    commit('hideDialog');
                    dispatch('loadSessions', state.ssoId);
                    resolve();
                })
                .catch(() => {
                    commit('setDeleting', false);
                    reject();
                });
        });
    },

    terminateAllSessions({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            commit('setDeleting', true);
            Api.customer.terminateAllSessions(state.ssoId)
                .then(() => {
                    commit('setDeleting', false);
                    commit('hideDeleteAllDialog');
                    dispatch('loadSessions', state.ssoId);
                    resolve();
                })
                .catch(() => {
                    commit('setDeleting', false);
                    dispatch('loadSessions', state.ssoId);
                    reject();
                });
        });
    },

    loadSessions({ commit }, ssoId) {
        commit('setLoading', true);
        commit('setSsoId', ssoId);
        commit('setSessions', []);
        Api.customer.getSessions(ssoId)
            .then(({ data }) => {
                commit('setSessions', data);
            })
            .catch(() => {
                commit('setSessions', []);
            })
            .finally(() => {
                commit('setLoading', false);
            });
    },
};

const mutations = {
    hideDeleteAllDialog(state) {
        state.showDeleteAllDialog = false;
    },

    openDeleteAllDialog(state) {
        state.showDeleteAllDialog = true;
    },

    hideDialog(state) {
        state.showDialog = false;
        state.selectedSessionId = '';
    },

    openDialog(state, sessionId) {
        state.showDialog = true;
        state.selectedSessionId = sessionId;
    },

    setSessions(state, sessions) {
        state.plainSessions = sessions;
    },

    setSsoId(state, ssoId) {
        state.ssoId = ssoId;
    },

    resetSelectedSession(state) {
        state.selectedSessionId = '';
    },

    setDeleting(state, deleting) {
        state.deleting = deleting;
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    resetSate(state) {
        state.plainSessions = [];
        state.loading = false;
        state.deleting = false;
        state.showDialog = false;
        state.showDeleteAllDialog = false;
        state.selectedSessionId = '';
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
